import React from "react";
import { Link } from "react-router-dom";
import "../styles/Pages.css";

export default function NotFound() {
	return (
		<>
			<title>Page not found | B & H Machining</title>
			<meta name="robots" content="noindex" />
			<section className="wrap not-found">
				<h1>Page not found</h1>
				<p>The page you're looking for has moved or no longer exists.</p>
				<Link to="/" className="button button--primary">
					Go to the home page
				</Link>
			</section>
		</>
	);
}
